import { render, staticRenderFns } from "./ScopeGroupLabel.vue?vue&type=template&id=708995f4&"
import script from "./ScopeGroupLabel.vue?vue&type=script&lang=js&"
export * from "./ScopeGroupLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports